import { customerApi } from "./customer.api";

/**
 * Export generated hooks for use in components
 */
export const {
  useGetCustomersQuery,
  useGetCustomerQuery,
  useEditCustomerMutation,
  useDeleteCustomerMutation,
  useListCustomersInfiniteQuery,
  useSearchCustomersQuery,
  useLazySearchCustomersQuery
} = customerApi;
